import { render, staticRenderFns } from "./AgencyContestDataTable.vue?vue&type=template&id=61c75afb&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./AgencyContestDataTable.vue?vue&type=script&lang=js&"
export * from "./AgencyContestDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AgencyContestDataTable.vue?vue&type=style&index=0&id=61c75afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c75afb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
